import { useState } from "react";
import {
  
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import Layout from "./components/Layout";
import Container from "./components/Container";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Top from "./components/Top";
import WrapperTop from "./components/WrapperTop";
import Title from "./components/Title";
import Navigation from "./components/Navigation";
import Banner from "./components/Banner";
import Footer from "./components/Footer";
import Bottom from "./components/Bottom";
import ProductDetail from "./components/ProductDetail";
import Checkout from "./components/Checkout";
import ViewCart from "./components/ViewCart";
import Payment from "./components/Payment";
import Faucet from "./components/Faucet";

const App = () => {
  const navigate = useNavigate();
  const [carrito, setCarrito] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [formShipping, setFormShipping] = useState({});
  

  const handleSubmitFormShipping = (datos) => {
    setFormShipping(datos);
    return navigate("/payment");
  };

  const toggleIsVisible = () => {
    setIsVisible(!isVisible);
  };

  const addToCart = (product) => {
    if (carrito.find((x) => x.id === product.id)) {
      const newCart = carrito.map((x) =>
        x.id === product.id ? { ...x, cantidad: x.cantidad + 1 } : x
      );
      return setCarrito(newCart);
    }

    return setCarrito(carrito.concat({ ...product, cantidad: 1 }));
  };

  const updateCart = (id, cantidad) => {
    const newCart = carrito.map((x) =>
      x.id === id ? { ...x, cantidad: Number(cantidad) } : x
    );
    return setCarrito(newCart);
  };

  const removeFromCart = (id) => {
    const newCart = carrito.filter((x) => x.id !== id);
    return setCarrito(newCart);
  };

  const emptyCart = () => {
    return setCarrito([]);
  };

  return (
    <>
      <Layout>
        <Top />
        <Container>
          <WrapperTop
            carrito={carrito}
            isVisible={isVisible}
            toggleIsVisible={toggleIsVisible}
          />
          <Title />
          <Navigation />
          <Routes>
            <Route path="/" exact element={<Home addToCart={addToCart} />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/checkout"
              element={
                <Checkout
                  carrito={carrito}
                  formShipping={formShipping}
                  handleSubmitFormShipping={handleSubmitFormShipping}
                />
              }
            />
            <Route
              path="/payment"
              element={<Payment carrito={carrito} emptyCart={emptyCart}  formShipping={formShipping} />}
            />
            <Route path="/faucet-dai" element={<Faucet token="DAI" />} />
            <Route
              path="/view-cart"
              element={
                <ViewCart
                  carrito={carrito}
                  removeFromCart={removeFromCart}
                  updateCart={updateCart}
                />
              }
            />
            <Route path="/product/detail/:id" element={<ProductDetail addToCart={addToCart} />} />
          </Routes>
        </Container>
      </Layout>
      <Banner />
      <Footer />
      <Bottom />
    </>
  );
};

export default App;
